<template>
  <form v-if="stateIsReady" class="w-full m-center" @submit="submit">
    <div class="content flex flex-wrap">
      <h1 class="mb-6">Carta prepagata</h1>

      <div class="w-full mb-3">
        <div
          class="outline-link"
          :class="{ read: contract.read }"
          @click="openContract(contract.documentId)"
        >
          <div class="outline-link__text">{{ contract.description }}</div>
          <div class="outline-link__status">
            {{ contract.read ? "Letto" : "Leggi per proseguire" }}
          </div>
        </div>
      </div>

      <div v-if="contract.read">
        <div
          class="w-full mt-5 mb-3 font-system"
          v-for="sign in contract.signs"
          :key="sign.id"
        >
          <div class="tnb-checkbox">
            <div class="inline-flex">
              <input type="checkbox" :id="sign.id" v-model="sign.checked" />
              <label v-html="sign.description" :for="sign.id"></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button
        class="btn"
        type="submit"
        :disabled="
          !contract.read ||
            contract.signs.filter(s => s.checked).length < contract.signs.length
        "
      >
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import DocumentsService from "@/services/DocumentsService";
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";

//import validations from "@/utils/validations";
//import ValidationText from "@/components/ValidationText";

export default {
  name: "InfocertSign",
  components: {
    // ValidationText
  },
  data() {
    return {
      contract: {}
    };
  },
  validations: {
    privacyTerm: {
      checked: {
        sameAs: sameAs(() => true)
      }
    },
    generalConditionRead: {
      sameAs: sameAs(() => true)
    }
  },
  computed: {
    stateIsReady: function() {
      if (this.$store.state.user.minor !== undefined) this.stateReady();
      return this.$store.state.user.minor !== undefined;
    }
  },
  mounted() {},
  methods: {
    stateReady() {
      DocumentsService.getCurrentFlowStaticContracts().then(contracts => {
        this.contract = contracts
          .filter(c => c.type === "DP_CARD_M")
          .map(c => {
            c.read = false;
            c.signs = [
              {
                id: 1017540,
                description:
                  "Dichiaro di aver preso visione e di accettare tutte le dichiarazioni di cui alle lettere a) – j) del Modulo di richiesta. Prendo, inoltre, atto che l´impossibilità di completare l´adeguata verifica impedirà l´instaurazione o la prosecuzione del rapporto",
                signId: "firma_0"
              },
              {
                id: 1017541,
                description:
                  "Dichiaro di aver ricevuto il «Foglio Informativo» e la presente proposta contrattuale, debitamente compilata e comprensiva del «Documento di sintesi»",
                signId: "firma_1"
              },
              {
                id: 1017542,
                description:
                  'Dichiaro la correttezza di quanto indicato relativamente allo stato di "Persona Politicamente Esposta"',
                signId: "firma_2"
              },
              {
                id: 1017543,
                description:
                  "Dichiaro di aver preso conoscenza e di approvare specificatamente le seguenti clausole e condizioni del Regolamento Titolari: Art. 4 - Trasformazione della Carta e conclusione del Contratto; Art. 6 - Condizione risolutiva; Art. 7 - Durata del Contratto e validità della Carta; Art. 8 - Disponibilità Massima della Carta, caricamento e disponibilità di spesa residua; Art. 9 - Uso della Carta; Art. 13 - Rapporti con gli Esercenti; Art. 21 - Pagamenti; Art. 23 - Comunicazioni periodiche e informazioni successive rispetto ad Operazioni di pagamento e di prelievo di denaro contante; Art. 31 - Obblighi del Cliente in relazione all’utilizzo della Carta, del PIN e degli elementi legati all’Autenticazione Forte del Cliente, in particolare in caso di smarrimento, furto, appropriazione indebita, uso non autorizzato, falsificazione o contraffazione; Art. 34 - Blocco della Carta; Art. 35 - Clausola risolutiva espressa; Art. 36 - Recesso del Cliente; Art. 38 -Modifiche al Contratto; Art. 45 - Lingua del Contratto, legge applicabile e Foro competente.",
                signId: "firma_3"
              },
              {
                id: 1017544,
                description:
                  "Confermo le scelte effettuate precedentemente in relazione ai consensi facoltativi per il trattamento dei dati personali",
                signId: "firma_4"
              }
            ];
            return c;
          })[0];
      });
    },
    openContract(id) {
      this.contract.read = true;
      this.openStaticContract(id);
    },
    openStaticContract(id) {
      var url = DocumentsService.getStaticContractUrlFromId(id);
      DocumentsService.openDocument(url);
    },
    submit() {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;
      this.stepCompleted();
    },
    async stepCompleted() {
      try {
        await RegistrationService.upgradeRegistrationProgress(3);
        this.$root.$emit("submitStep");
      } catch (error) {
        const errorCode = error?.response?.data?.context?.code || "";

        switch (errorCode) {
          case "WAL_010012":
            //TODO: show modal not enough balance
            this.$root.$emit("openModal", "modalBalanceError");
            break;

          default:
            UtilityService.showDefaultError(error);
            break;
        }
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.tnb-radio {
  align-items: center;
  label {
    margin: 0;
  }
}
</style>
